module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR AND TWENTY BLACKBIRDS")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2003, 2005 by Cherie Priest")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Unrevised, shorter version published in 2003 by Marietta Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce this book, or portions thereof, in any form.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Edited by Liz Gorinsky")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Book design by Nicole de las Heras")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A Tor Book"), _c('br'), _vm._v("Published by Tom Doherty Associates, LLC"), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.tor.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tor.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Tor"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Tom Doherty Associates, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Priest, Cherie.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Four and twenty blackbirds / Cherie Priest.—1st Tor ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("    p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("“A Tom Doherty Associates Book.”")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 0-765-31308-1 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("EAN 978-0-765-31308-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Orphans—Fiction. 2. Young women—Fiction. 3. Blessing and cursing—Fiction. 4. Racially mixed people—Fiction. 5. Signal Mountain (Tenn.)—Fiction. 6. Birthfathers—Fiction. 7. Georgia—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("PS3616.R537F685 2005"), _c('br'), _vm._v("813’.6—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("2005040584")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Tor Edition: October 2005")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10   9   8   7   6   5   4   3")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0